import React, { Component } from 'react';
import {
    Col,
    Row,
    Container,
    Card,
    Button,
    CardBody,
    InputGroup,
    InputGroupAddon,
    Dropdown,
    DropdownToggle, DropdownMenu, DropdownItem, Tooltip
} from "reactstrap";
import Select from 'react-select';
// import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import connect from "react-redux/es/connect/connect";
import { setBusSearch } from "../../redux/actions/search";
// import validator from "validator";
// import {LangValidation} from "../../lang/fa/validation";
import MiladiDate from '../Calendar/MiladiDate';
import ShamsiDate from '../Calendar/ShamsiDate';
import SingleMiladiDate from "../Calendar/SingleMiladiDate"
import SingleShamsiDate from "../Calendar/SingleShamsiDate"
import { BUS_STATIONS, SELECTED_BUS_STATIONS } from "../../containers/bus/BusConfig";
// import * as moment from 'moment';



class BannerLink extends Component {
    constructor(props) {
        super(props);
        this.renderDay = this.renderDay.bind(this)
        this.state = {
            fields: {
                type: "1",
                origin: null,
                destination: null,
                departureDate: null,
                origin2: null,
                destination2: null,
                departureDate2: null,
                adult: 1,
                child: 0,
                infant: 0,
                preferences: 0,
                originname: '',
                destinationname: '',
            },
            type: "1",
            originItem: null,
            destinationItem: null,
            errors: {},
            dropdownOpen: false,
            birthdays: {
                20: '45 $',
            },
            redirect: false,
            data: null,
            arivaldate: null,
            arivalfocused: null,
            Shamsi: false,
            tooltipOpen: false,
        }
    }

    toMiladi() {
        this.setState(prevState => ({
            Shamsi: !prevState.Shamsi
        }))
    }
    toggletooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }



    render() {
        // const { fields } = this.state;
        // console.log(this.state.fields.type)
        // console.log(selectedairports)
        const groupedOptions = [
            {
                label: 'Elected States',
                options: SELECTED_BUS_STATIONS
            },
            {
                label: 'Other States',
                options: BUS_STATIONS
            },
        ];

        return (
            <div className="justify-content-center w-100">
                <Container>
                    <Card body className="searchBox">
                        <CardBody>

                            <Row className="no-gutters">
                                <Col md="5" sm="12" className="searchBox_col origin-box">
                                    <InputGroup className="input-group md-form2">
                                        <InputGroupAddon addonType="prepend" className='addon'>
                                            <i className="la la-map-marker"></i>
                                        </InputGroupAddon>
                                        <Select
                                            className="select-box "
                                            label="Origin"
                                            icon="envelope"
                                            placeholder="Origin"
                                            // isClearable={true}
                                            isSearchable={true}
                                            // defaultValue={fields.origin}
                                            name="origin"
                                            value={this.state.originItem}
                                            onChange={this.handleSelect.bind(this, "origin")}
                                            options={groupedOptions}
                                        />

                                        <Button color="link" className="reverseBtn" onClick={this.handleReverse.bind(this)}>
                                            <i className="la la-exchange" />
                                        </Button>
                                    </InputGroup>

                                    <InputGroup className="input-group">
                                        <InputGroupAddon addonType="prepend" className='addon'>
                                            <i className="la la-map-marker" />
                                        </InputGroupAddon>
                                        <Select
                                            className="select-box destination-box"
                                            placeholder="To where ?"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="destination"
                                            // defaultValue="IKA"
                                            value={this.state.destinationItem}
                                            onChange={this.handleSelect.bind(this, "destination")}
                                            options={groupedOptions}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col md="3" sm="12" className="searchBox_col singel-ariival-date">
                                    <InputGroup className={(this.state.fields.type === "1") ? "input-group w-100 single-date-selection" : "input-group range-date-selection"}>
                                        <InputGroupAddon addonType="prepend" className='addon'>
                                            <Button color="secondary" onClick={this.toMiladi.bind(this)} className='changeto-persian-button' id="TooltipExample" >
                                                {/* <i className="la la-calendar-check-o"></i> */}
                                                <img className='change-cal-img' src='/assets/images/cal.png' alt='change-calander' />
                                            </Button>
                                            <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipExample" toggle={this.toggletooltip.bind(this)}>
                                                Change Calendar !
                                            </Tooltip>
                                        </InputGroupAddon>
                                        {/* <DayPickerInput
                                            placeholder="Departure Date"
                                            selectedDays={fields.departureDate}
                                            onDayChange={this.handleDayChange.bind(this)}
                                        // dayPickerProps={{renderDay:this.renderDay}}
                                        /> */}
                                        {this.state.fields.type === "1" ?
                                            <div className='innder-single-date'>
                                                {this.state.Shamsi ?
                                                    <SingleShamsiDate set={this.HandelDay.bind(this)} />
                                                    :
                                                    <SingleMiladiDate set={this.HandelDay.bind(this)} />

                                                }
                                            </div>
                                            :
                                            <div className='round-trip-home'>
                                                {this.state.Shamsi ?
                                                    <ShamsiDate />
                                                    :
                                                    <MiladiDate />
                                                }
                                            </div>
                                        }
                                    </InputGroup>

                                    {/* {(this.state.fields.type === "2") ?
                                        <InputGroup className="input-group">
                                            <InputGroupAddon addonType="prepend" className='addon'>
                                                <i className="la la-calendar-check-o"></i>
                                            </InputGroupAddon>
                                            <DayPickerInput
                                                placeholder="Return Date"
                                                selectedDays={fields.departureDate2}
                                                onDayChange={this.handleDayChange2.bind(this)}
                                            // dayPickerProps={{renderDay:this.renderDay}}
                                            />
                                        </InputGroup> : ""} */}
                                </Col>
                                <Col md="3" sm="12" className="searchBox_col type-numbers">
                                    <InputGroup className="input-group w-100">
                                        <InputGroupAddon addonType="prepend" className='addon'>
                                            <i className="la la-group"></i>
                                        </InputGroupAddon>
                                        <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })} className="passenger-btn">
                                            <DropdownToggle className="passenger-toggle">
                                                {(this.state.fields.adult > 0) ? <span>{this.state.fields.adult} Adult</span> : <span>Passenger no.</span>}
                                                {(this.state.fields.child > 0) ? <span>,{this.state.fields.child} Child</span> : ''}
                                                {(this.state.fields.infant > 0) ? <span>,{this.state.fields.infant} Infant</span> : ''}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem header>
                                                    <Button color="link" className="tochSpinBtn" onClick={this.handleTochSpin.bind(this, 'adult', -1)}><i className="la la-minus-circle"></i></Button>
                                                    Adult
                                                    <Button color="link" className="tochSpinBtn" onClick={this.handleTochSpin.bind(this, 'adult', 1)}><i className="la la-plus-circle "></i></Button>
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem header>
                                                    <Button color="link" className="tochSpinBtn" onClick={this.handleTochSpin.bind(this, 'child', -1)}><i className="la la-minus-circle"></i></Button>
                                                    Child
                                                    <Button color="link" className="tochSpinBtn" onClick={this.handleTochSpin.bind(this, 'child', 1)}><i className="la la-plus-circle "></i></Button>
                                                </DropdownItem>
                                                <DropdownItem header>
                                                    <Button color="link" className="tochSpinBtn" onClick={this.handleTochSpin.bind(this, 'infant', -1)}><i className="la la-minus-circle"></i></Button>
                                                    Infant
                                                    <Button color="link" className="tochSpinBtn" onClick={this.handleTochSpin.bind(this, 'infant', 1)}><i className="la la-plus-circle "></i></Button>
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </InputGroup>
                                </Col>
                                <Col md="1" sm="12" className="searchBox_col">
                                    <Button block color="primary" className='searchBox-btn' onClick={this.handleClick.bind(this)}>Search</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        );
    }

    HandelDay(e) {
        // console.log(e);
        let fields = this.state.fields;
        fields.departureDate = e
        this.setState({
            fields
        });
        // console.log(this.state.fields)
    }

    handleTochSpin(type, value) {
        let fields = this.state.fields;
        if ((this.state.fields[type] + value) > -1) {
            fields[type] = this.state.fields[type] + value
        }
        this.setState({
            fields
        })
    }
    handleReverse() {
        let fileds = this.state.fields;
        let orgin = this.state.fields.origin;
        let destination = this.state.fields.destination;
        let originItem = this.state.originItem;
        let destinationItem = this.state.destinationItem;

        fileds.origin = destination;
        fileds.destination = orgin;
        // console.log(fileds);
        this.setState({
            fileds,
            originItem: destinationItem,
            destinationItem: originItem,
        });
    }
    handleSelect = (type, value) => {
        console.log(type)
        console.log(value)
        let fields = this.state.fields;
        fields[type] = value.value;
        let item = {
            value: value.value,
            label: value.label
        };
        let originItem = this.state.originItem;
        let destinationItem = this.state.destinationItem;
        if (type === 'origin') {
            originItem = item;
        } else {
            destinationItem = item;
        }
        this.setState({
            fields,
            originItem,
            destinationItem
        })
    };
    handleDayChange(selectedDay, modifiers, dayPickerInput) {
        let fields = this.state.fields;
        const input = dayPickerInput.getInput();
        fields.departureDate = input.value;
        this.setState({
            fields
        });

    }
    handleDayChange2(selectedDay, modifiers, dayPickerInput) {
        let fields = this.state.fields;
        const input = dayPickerInput.getInput();
        fields.departureDate2 = input.value;
        this.setState({
            fields
        });
    }
    handleOptionChange(value) {
        let fields = this.state.fields;
        fields.type = value;
        console.log(fields);
        this.setState({
            fields
        });
    }
    handleClick = (e) => {
        e.preventDefault();

        let fields = this.state.fields;
        let error = "";
        if (fields.origin === null) {
            error = "Please select origin!";
        } else if (fields.destination === null) {
            error = "Please select destination!";
        } else if (fields.adult === 0) {
            error = "Adult number can't be less than 1.";
        } else if (fields.departureDate === null) {
            error = "Please Choose departure date!";
        } else if ((fields.type === 2) && (fields.departureDate2 === null)) {
            error = "Please Choose return date!";
        }

        if (error !== "") {
            toast.error(error, {
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT,
                rtl: false
            });
        } else {
            let data = {};
            const passengerquantity = this.state.fields.adult + this.state.fields.child + this.state.fields.infant;
            data = {
                "OriginStationCode": this.state.fields.origin,
                "DestinationStationCode": this.state.fields.destination,
                "DepartureDate": this.state.fields.departureDate,
                "PassengerCount": passengerquantity,
                "AirTravelerAvail": [
                    {
                        "Quantity": this.state.fields.adult,
                        "PassengerType": 1
                    },
                    {
                        "Quantity": this.state.fields.child,
                        "PassengerType": 2
                    },
                    {
                        "Quantity": this.state.fields.infant,
                        "PassengerType": 3
                    }
                ]
            };

            this.props.setBusSearch(data);
            // console.log(data)
            window.location.replace("/search-bus");

        }
    };

    renderDay(day) {
        const { birthdays } = this.state;
        const date = day.getDate();
        const dateStyle = {
            position: 'absolute',
            // color: 'lightgray',
            bottom: 0,
            right: 0,
            fontSize: 12,
        };
        const cellStyle = {
            height: 35,
            width: 35,
            position: 'relative',
            // border:'1px solid #999',
            margin: 0
        };
        const priceStyle = {
            clear: 'both',
            display: 'block',
            // background:'#999',
            // color:'#fff',
            fontSize: '10',
            width: 35
        };
        return (
            <div style={cellStyle}>
                <div style={dateStyle}>{date}
                    {birthdays[date] ? <span style={priceStyle}>{birthdays[date]}</span> : <span style={priceStyle}>&nbsp;</span>}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setBusSearch: search => {
            dispatch(setBusSearch(search))
        }
    }
};
export default connect(null, mapDispatchToProps)(withRouter(BannerLink));


// WEBPACK FOOTER //
// ./src/components/banner/BusSearch.jsx